import { Alert } from "react-bootstrap";
import { InputHTMLAttributes } from "react";

import "./AmplifyError.scss";

interface AmplifyErrorProps extends InputHTMLAttributes<HTMLInputElement> {
  errors: string[]
}

const AmplifyError = ({ errors }: AmplifyErrorProps) => (
  <>
    {errors.length > 0
        && (
          <Alert variant="danger">
            {errors.map((error : string, idx: number) => <span key={`amplifyError_${idx}`} className="error-amplify">{error}</span>)}
          </Alert>
        )}
  </>
);

export default AmplifyError;
